// import useAuth from 'hooks/useAuth';
// import { Doc } from '../preferences/preferenceApi';
import { store } from 'store';
import apiSlice from 'store/slices/apiSlice';

const apiHost = process.env.REACT_APP_API_URL;
const api_key = process.env.REACT_APP_OPENAI_KEY;

export function fetchAnswerSteaming(question, model, apiKey, selectedDocs, history = [], conversationId, project, onEvent) {
    // let namePath = selectedDocs.name;

    // if (selectedDocs.language === namePath) {
    //   namePath = '.project';
    // }

    // let docPath = 'default';
    // if (selectedDocs.location === 'local') {
    //   docPath = 'local' + '/' + localStorage.getItem('user_token') + '/' + project + '/' + selectedDocs.name + '/';
    // } else if (selectedDocs.location === 'remote') {
    //   docPath =
    //     selectedDocs.language +
    //     '/' +
    //     namePath +
    //     '/' +
    //     selectedDocs.version +
    //     '/' +
    //     selectedDocs.model +
    //     '/';
    // }

    // console.log(docPath)

    history = history.map((item) => {
        return { prompt: item.prompt, response: item.response };
    });
    // console.log("model", model)
    if (model === 'gpt-4-1106') {
        return new Promise((resolve, reject) => {
            const body = {
                question: question,
                api_key: api_key,
                embeddings_key: api_key,
                history: JSON.stringify(history),
                active_docs: '',
                conversation_id: conversationId,
                user: localStorage.getItem('user_token'),
                user_type: localStorage.getItem('user_type'),
                project: project
            };

            // console.log(body)

            fetch(`${apiHost}/stream/chatgpt`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            })
                .then((response) => {
                    if (!response.body) throw Error('No response body');

                    const reader = response.body.getReader();
                    const decoder = new TextDecoder('utf-8');
                    let counterrr = 0;
                    const processStream = ({ done, value }) => {
                        if (done) {
                            // console.log(counterrr);
                            return;
                        }

                        counterrr += 1;

                        const chunk = decoder.decode(value);

                        const lines = chunk.split('\n');

                        for (let line of lines) {
                            // console.log(line)
                            if (line.trim() == '') {
                                continue;
                            }
                            if (line.startsWith('data:')) {
                                line = line.substring(5);
                            }
                            // console.log(line)
                            const messageEvent = new MessageEvent('message', {
                                data: line
                            });

                            onEvent(messageEvent); // handle each message
                        }

                        reader.read().then(processStream).catch(reject);
                    };

                    reader.read().then(processStream).catch(reject);
                })
                .catch((error) => {
                    console.error('Connection failed:', error);
                    reject(error);
                });
        });
    } else {
        return new Promise((resolve, reject) => {
            const headers = {
                Accept: 'text/event-stream',
                'Content-Type': 'application/json'
            };
            // const body = {
            //   question: question,
            //   model: model,
            //   api_key: api_key,
            //   embeddings_key: api_key,
            //   history: JSON.stringify(history),
            //   active_docs: "",
            //   conversation_id: conversationId,
            //   user: localStorage.getItem('user_token'),
            //   user_type: localStorage.getItem('user_type'),
            //   project: project
            // };

            // console.log(body)

            // fetch(`${apiHost}/stream/chatgpt/free`, {
            //   method: 'POST',
            //   headers: {
            //     'Content-Type': 'application/json',
            //   },
            //   body: JSON.stringify(body),
            // })
            //   .then((response) => {
            //     if (!response.body) throw Error('No response body');

            //     const reader = response.body.getReader();
            //     const decoder = new TextDecoder('utf-8');
            //     let counterrr = 0;
            //     const processStream = ({
            //       done,
            //       value,
            //     }) => {
            //       if (done) {
            //         // console.log(counterrr);
            //         return;
            //       }

            //       counterrr += 1;

            //       const chunk = decoder.decode(value);

            //       const lines = chunk.split('\n');

            //       for (let line of lines) {
            //         if (line.trim() == '') {
            //           continue;
            //         }
            //         if (line.startsWith('data:')) {
            //           line = line.substring(5);
            //         }

            //         const messageEvent = new MessageEvent('message', {
            //           data: line,
            //         });

            //         onEvent(messageEvent); // handle each message
            //       }

            //       reader.read().then(processStream).catch(reject);
            //     };

            //     reader.read().then(processStream).catch(reject);
            //   })
            //   .catch((error) => {
            //     console.error('Connection failed:', error);
            //     reject(error);
            //   });

            const body = {
                id: conversationId,
                conversation_id: conversationId,
                model: model,
                web_search: false,
                provider: '',
                messages: [
                    {
                        role: 'user',
                        content: question
                    }
                ],
                auto_continue: true,
                api_key: null
            };

            console.log('body', body);

            if (window.controller) {
                window.controller.abort();
            }
            window.controller = new AbortController();
            window.signal = window.controller.signal;

            fetch('https://youteach.ai:5014/backend-api/v2/conversation', {
                method: 'POST',
                signal: window.controller.signal,
                headers: headers,
                body: JSON.stringify(body)
            })
                .then((response) => {
                    console.log('response', response);
                    if (!response.body) throw Error('No response body');

                    // const reader = response.body.getReader();
                    const decoder = new TextDecoder('utf-8');
                    let counterrr = 0;
                    const reader = response.body.pipeThrough(new TextDecoderStream()).getReader();
                    // console.log(reader.read())
                    let buffer = '';
                    // while (true) {
                    //     const { value, done } = reader.read();
                    //     console.log(value)
                    //     if (done) {
                    //         break;
                    //     }
                    //     for (const line of value.split("\n")) {
                    //         if (!line) {
                    //             continue;
                    //         }
                    //         try {
                    //             const messageEvent = new MessageEvent('message', {
                    //               data: JSON.parse(buffer + line),
                    //             });
                    //             onEvent(messageEvent);
                    //             // add_message_chunk(JSON.parse(buffer + line))
                    //             console.log(JSON.parse(buffer + line))
                    //             buffer = "";
                    //         } catch {
                    //             buffer += line
                    //         }
                    //     }
                    // }
                    // while(true){
                    const processStream = ({ done, value }) => {
                        if (done) {
                            // console.log('{"type": "end"}');
                            const messageEvent = new MessageEvent('message', {
                                data: '{"type": "end"}'
                            });
                            onEvent(messageEvent);
                            return;
                        }
                        // console.log('value',value)
                        counterrr += 1;

                        // const chunk = decoder.decode(value);
                        // console.log('chunk', chunk)
                        // const lines = chunk.split('\n');

                        // for (let line of lines) {
                        //   if (line.trim() == '') {
                        //     continue;
                        //   }
                        //   if (line.startsWith('data:')) {
                        //     line = line.substring(5);
                        //   }

                        //   const messageEvent = new MessageEvent('message', {
                        //     data: line,
                        //   });

                        //   onEvent(messageEvent); // handle each message
                        // }

                        for (const line of value.split('\n')) {
                            if (!line) {
                                continue;
                            } else if (JSON.parse(line)['content'] !== undefined) {
                                try {
                                    // console.log('{"answer": "' + buffer + JSON.parse(line)['content'].replace('"',"'") + '"}')
                                    const messageEvent = new MessageEvent('message', {
                                        data: '{"answer": "' + buffer + JSON.parse(line)['content'].replace('"', "'") + '"}'
                                    });
                                    onEvent(messageEvent);
                                    // add_message_chunk(JSON.parse(buffer + line))
                                    // console.log({"answer": buffer + JSON.parse(line)['content']})
                                    buffer = '';
                                } catch {
                                    buffer += JSON.parse(line)['content'].replace('"', "'");
                                }
                            }
                        }

                        reader.read().then(processStream).catch(reject);
                    };
                    reader.read().then(processStream).catch(reject);
                    // }
                })
                .catch((error) => {
                    console.log('error');
                    console.error('Connection failed:', error);
                    reject(error);
                });
        });
    }
}

export async function sendFeedback(prompt, response, feedback) {
    const res = await store.dispatch(
        apiSlice.endpoints.postChatFeedback.initiate({
            question: prompt,
            answer: response,
            feedback,
            user: localStorage.getItem('user_token')
        })
    );
    if (res?.data !== undefined || res?.isSuccess) return Promise.resolve();
    return Promise.reject();
}
